import Vue from 'vue';
import AllPersonalInfoService from './AllPersonalInfoService';
import ErrorHelper from './ErrorHelper';
import LoginForm from './LoginForm.vue'
import store from './store';
import docAppBar from '@/DocAppBar.vue';
import gpxPlanner from '@/DocGPXPlanner.vue';
import LogoutService from './LogoutService';
import { UserMessageCommand } from './UserMessageCommand';
import { Command } from './Command';

const confirmDeleteAllDialog = 'confirmdeleteall'
export default Vue.extend({
    name: "Privacy",
    components: {
        LoginForm,
        docAppBar,
        gpxPlanner
    },
    data: () => ({
        dialog: '',
        snackbarText: '',
        snackbar: false,
        snackbarColor: '',
        confirmDeleteAllAnswer: '',
        loading: false,
        downloadAllPersonalInfoUrl: AllPersonalInfoService.DownloadUrl()
    }),
    computed:{
        showConfirmDeleteAll: {
            get() {
                return this.dialog === confirmDeleteAllDialog
            }
        },
        deleteAllConfirmed: {
            get() {
                return this.confirmDeleteAllAnswer.toLowerCase().trim() === 'delete'
            }
        }
    },
    async mounted() {
        const commands: Command[] = await this.$store.getters.userCommands
        commands.forEach(async command => {
            let handled = true
            if(command instanceof UserMessageCommand) {
                await this.handleUserMessageCommand(command)
            }
            else {
                handled = false
            }
            if(handled) {
                store.commit('handledCommand', command.id)
            }
        })
    },
    methods: {
        startDeleteAll() {
            this.confirmDeleteAllAnswer = ''
            this.dialog = confirmDeleteAllDialog
            setTimeout(() => {
                const toFocus = document.getElementById("confirmdeleteinput") as HTMLInputElement
                if(toFocus) {
                    toFocus.focus()
                }
            })    
        },
        async doDeleteAll() {
            try {
                this.loading = true
                await AllPersonalInfoService.DeleteAll(this.confirmDeleteAllAnswer)
                store.commit('logout')
                this.showInfo('All personal data successfully deleted.')
                this.dialog = ''
            }        
            catch(error) {
                console.error(error)
                ErrorHelper.ifUserError(error, (userError) => this.showError(userError)) || this.showError('An error occurred deleting data. Please contact support.')
            }
            finally {
                this.loading = false
            }

        },
        login() {
            this.dialog = 'login'
        },
        async logout() {
            try {
                await LogoutService.logout()
                await store.commit('logout')
                this.showInfo('Logged out successfully')
            } catch(error) {
                console.error(error)
                this.showError('Error logging out. Please clear cookies, as this will log you out.')
            }
        },
        showError: function (message: string) {
            this.snackbarText = message;
            this.snackbar = true
            this.snackbarColor = 'error'
        },
        showInfo: function (message: string) {
            this.snackbarText = message;
            this.snackbar = true
            this.snackbarColor = ''
        },
        onCloseDialog(message: string) {
            if (message) {
                this.showInfo(message)
            }
            this.dialog = ''
        },
        async handleUserMessageCommand(message: UserMessageCommand) {
            this.snackbar = true
            this.snackbarText = message.msg
            this.snackbarColor = message.color
    
            if(message.showLogin) {
                this.dialog = 'login'
            }
        }    
    }
})